import React from 'react';
const Row = ({
  location,
  own,
  accent_color
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: `list-row list-item ${location.ranking === (own === null || own === void 0 ? void 0 : own.ranking) && 'list-item-own'}`,
    style: {
      '--accent-color': accent_color
    }
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("span", {
    className: "ranking-prefix"
  }, location.ranking, "."), " ", location.location)), /*#__PURE__*/React.createElement("p", null, location.net ? `$${parseFloat(location.net).toFixed(2)}` : '-'));
};
export default Row;